import axios from '@axios'

export const state = {
  activityLogs: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allActivityLogs: (state) => state.activityLogs,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  GET_ACTIVITY_LOGS: (state, resp) => {
    if (!resp) return null
    state.activityLogs = resp.activityLogs
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
}

export const actions = {
  async getActivityLogs({ commit }, params = {}) {
    await axios
      .get('/api/activity-logs', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_ACTIVITY_LOGS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_ACTIVITY_LOGS',
          err.response.status === 404 ? { activityLogs: [] } : null
        )
      })
  },
}
